import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MaterialModule } from '@app/shared/material.module'
import { Select, Store } from '@ngxs/store'
import { QuoteSessionState } from '@app/shared/store/quote-session/quote-session.state'
import { QuoteSessionAction } from '@app/shared/store/quote-session/quote-session.actions'
import { debounceTime, map, Observable, pairwise, startWith, Subject, takeUntil } from 'rxjs'
import { Contact } from '@app/models/contact'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { Quote } from '@app/models/quote.model'
import { PetState } from '@app/shared/store/pet/pet.state'
import { Pet } from '@app/models/pet.model'
import { PetAction } from '@app/shared/store/pet/pet.actions'

@Component({
	selector: 'app-quote-important-notes',
	standalone: true,
	imports: [CommonModule, MaterialModule, ReactiveFormsModule],
	templateUrl: './quote-important-notes.component.html',
	styleUrls: ['./quote-important-notes.component.scss'],
})
export class QuoteImportantNotesComponent implements OnInit, OnDestroy {
	@Select(QuoteSessionState.contactState)
	public contact$!: Observable<Contact>
	@Select(QuoteSessionState.quoteState)
	public quote$!: Observable<Quote>
	@Select(PetState.activePets)
	public activePets$!: Observable<Pet[]>

	public petParentImportantNotes: FormControl<string | null>
	public displayImportantNotes: boolean = true
	public noData: boolean = false
	public contactFullName$: Observable<string>

	#ngUnsubscribe$: Subject<void> = new Subject()

	constructor(private readonly store: Store) {
		this.contactFullName$ = this.contact$.pipe(
			map((c) => `${c?.firstName ?? 'Pet'} ${c?.lastName ?? 'Parent'}`)
		)

		this.petParentImportantNotes = new FormControl()
	}

	@HostBinding('class')
	public get klassList(): string {
		return this.displayImportantNotes ? 'm--full-height' : ''
	}

	ngOnInit(): void {
		this.contact$
			.pipe(
				map((c) => c.ratingState),
				startWith(null),
				pairwise(),
				takeUntil(this.#ngUnsubscribe$)
			)
			.subscribe(([p, n]) => {
				if (!!p && !n) {
					this.petParentImportantNotes.reset(null, { emitEvent: false })
				}
			})

		this.contact$.pipe(takeUntil(this.#ngUnsubscribe$)).subscribe((contact) => {
			this.petParentImportantNotes.setValue(contact?.importantNotes ?? '', { emitEvent: false })
		})

		this.petParentImportantNotes.valueChanges
			.pipe(takeUntil(this.#ngUnsubscribe$), debounceTime(500))
			.subscribe((n) => {
				this.store.dispatch(new QuoteSessionAction.Contact.Update({ importantNotes: n ?? '' }))
			})
	}

	public trackFormChanges(index: number, item: any): number {
		return item.crmPetId
	}

	public handlePetImportantNotesChange(note: string | null, crmPetId?: string): void {
		if (!crmPetId) return
		this.store.dispatch(new PetAction.Update({ crmPetId, importantNotes: note || '' }))
	}

	ngOnDestroy(): void {
		this.#ngUnsubscribe$.next()
		this.#ngUnsubscribe$.unsubscribe()
	}
}
